var map = {
	"./1.png": 8852,
	"./10.png": 4734,
	"./11.png": 7223,
	"./12.png": 4572,
	"./13.png": 485,
	"./2.png": 2415,
	"./3.png": 678,
	"./4.png": 4937,
	"./5.png": 3760,
	"./6.png": 8795,
	"./7.png": 9794,
	"./8.png": 1797,
	"./9.png": 8908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1920;